import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { InternalError } from '@containers/shared/InternalError';

export const AppInternalError: FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const handleOnButtonClick = (): void => {
    window.location.href =
      window.location.origin + import.meta.env.VITE_ROUTER_BASENAME; // It reloads whole app with redirect to home page
  };

  return (
    <InternalError
      errorCode="500"
      description={t('AppInternalError.Description')}
      buttonLabel={t(
        pathname === '/'
          ? 'AppInternalError.RefreshPage'
          : 'AppInternalError.RedirectToHome',
      )}
      isFullscreen
      hasLogo
      onButtonClick={handleOnButtonClick}
    />
  );
};
